/**
 * Strips trailing zeros from price labels: "25.000,00 EUR" -> "25.000 EUR".
 * Safe for thousands separators because we only strip ",00" / ".00" when the
 * next character is non-digit (space, currency code, end of string, etc.).
 */
(function () {
  var RE = /([,.])00(?=\D|$)/g;

  function stripText(text) {
    if (!text || text.indexOf('00') === -1) return text;
    return text.replace(RE, '');
  }

  function stripIn(node) {
    if (!node) return;
    if (node.nodeType === Node.TEXT_NODE) {
      var next = stripText(node.nodeValue);
      if (next !== node.nodeValue) node.nodeValue = next;
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    var walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null);
    var t;
    while ((t = walker.nextNode())) {
      var next = stripText(t.nodeValue);
      if (next !== t.nodeValue) t.nodeValue = next;
    }
  }

  function run() {
    stripIn(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'characterData') {
          stripIn(m.target);
        } else if (m.addedNodes && m.addedNodes.length) {
          for (var j = 0; j < m.addedNodes.length; j++) {
            stripIn(m.addedNodes[j]);
          }
        }
      }
    });
    var start = function () {
      observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    };
    if (document.body) start();
    else document.addEventListener('DOMContentLoaded', start);
  }
})();
